<!-- <div class="page-container">
  <div class="relative page-edge-cut">
   
  </div>
</div> -->
<div class="form-card">
  <h1 class="section-heading">
    {{ venue.name }}
  </h1>

  <p class="text-sm lg:text-base text-dc-navy! mb-6 p-2!">
    {{ venue.desc }}
  </p>

  <!-- ICON LIST -->
  <ul class="space-y-3 mb-8 text-dc-navy! text-sm lg:text-base">
    <!-- capacity -->
    <li class="flex items-center gap-2">
      <i class="fa-solid fa-users text-dc-navy w-5"></i>
      {{ "VENUE.CAPACITY" | translate: { n: venue.capacity } }}
    </li>

    <!-- size -->
    <!-- <li class="flex items-center gap-2">
          <i class="fa-solid fa-ruler-combined text-dc-navy w-5"></i>
          {{ "VENUE.SIZE" | translate : { sqm: venue.size } }}
        </li> -->

    <!-- amenities -->
    <li class="flex items-center gap-2">
      <i class="fa-solid fa-chalkboard text-dc-navy w-5"></i>
      {{ venue.amenities }}
    </li>

    <!-- pricing -->
    <li class="flex items-start gap-2">
      <i class="fa-solid fa-ticket text-dc-navy w-5 mt-1"></i>
      <span>
        {{
          "VENUE.MEMBER_RATE"
            | translate: { price: venue.fullDayRate | number }
        }}<br />
        {{
          "VENUE.NON_MEMBER_RATE"
            | translate: { price: venue.fullDayRate | number }
        }}
      </span>
    </li>
  </ul>

  <!-- IMAGE CAROUSEL -->
  @if (venue?.sliderImages?.length > 0) {
  <div class="relative w-full max-w-xl h-72 overflow-hidden">
    <!-- Render ALL images -->
    @for (img of venue.sliderImages; let i = $index; track $index) {
      <img
        [src]="img?.url || venue.image"
        class="absolute inset-0 w-full h-72 object-cover transition-opacity duration-300"
        [class.opacity-100]="i === slide"
        [class.opacity-0]="i !== slide"
      />
    }

    @if (venue.sliderImages.length > 1) {
      <!-- Prev -->
      <button
        class="absolute top-1/2 -translate-y-1/2 left-3 bg-white/60 rounded-full p-1 hover:bg-white"
        (click)="prev()">
        <img src="/icons/svg/chevron-right.svg" class="rotate-180" />
      </button>

      <!-- Next -->
      <button
        class="absolute top-1/2 -translate-y-1/2 right-3 bg-white/60 rounded-full p-1 hover:bg-white"
        (click)="next()">
        <img src="/icons/svg/chevron-right.svg" />
      </button>

      <!-- Dots -->
      <div class="absolute bottom-2 inset-x-0 flex justify-center gap-1">
        @for (img of venue.sliderImages; let i = $index; track $index) {
          <button
            class="w-2 h-2 rounded-full"
            [class.bg-dc-navy]="i === slide"
            [class.bg-white]="i !== slide"
            (click)="slide = i">
          </button>
        }
      </div>
    }
  </div>
}

  <div class="btn-section buttons-group mt-10">
    <app-button
      type="button"
      [label]="'BUTTONS.CLOSE' | translate"
      classesName="btn-edge-cut btn-width-auto"
      (onBtnClick)="backToVeneusList()"
    >
    </app-button>
  </div>
</div>
